var map = {
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./3.png": "619a",
	"./4.png": "33b2",
	"./5.png": "4660",
	"./6.png": "97ca",
	"./7.png": "8efd",
	"./8.png": "570d",
	"./9.png": "0768",
	"./about_us_banner.png": "5556",
	"./banner.png": "1936",
	"./class_banner.png": "a8b7",
	"./down.png": "7c7c",
	"./huiyi.png": "7b74",
	"./intro1.png": "c00d",
	"./intro6.png": "f061",
	"./logo.png": "9d64",
	"./nav_1.png": "4c6d",
	"./nav_sel.png": "10fe",
	"./start.png": "1d4a",
	"./subject_bg1.png": "62ab",
	"./subject_bg2.png": "6b17",
	"./subject_bg3.png": "d49b",
	"./subject_bg4.png": "a8dc",
	"./subject_bg5.png": "eace",
	"./videobg.png": "ba36",
	"./测试.png": "008d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";